
export let APINotSupportedForRDLError: string = "This API is currently not supported for RDL reports";
export let EmbedUrlNotSupported = "Embed URL is invalid for this scenario. Please use Power BI REST APIs to get the valid URL";




// WEBPACK FOOTER //
// ./src/errors.ts